import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { BadgeCheck, X } from 'lucide-react';
import { apiGet, apiPost } from '../../lib/api.js';

export const PRODUCER_STATUS_KEY = ['producer-page', 'status'];

/**
 * Dashboard nudge toward the optional Producer Validation Page.
 * Hidden once the page is published or the agent dismisses it.
 * @returns {JSX.Element|null}
 */
export default function ProducerPageBanner() {
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: PRODUCER_STATUS_KEY,
    queryFn: () => apiGet('/producer-page/status').catch(() => null),
    staleTime: 60_000,
  });
  const dismiss = useMutation({
    mutationFn: () => apiPost('/producer-page/banner/dismiss', {}),
    onMutate: () => qc.setQueryData(PRODUCER_STATUS_KEY, (d) => ({ ...(d || {}), ok: true, dismissed: true })),
    onSettled: () => qc.invalidateQueries({ queryKey: PRODUCER_STATUS_KEY }),
  });

  if (!data?.ok || data.published || data.dismissed) return null;

  return (
    <div className="panel flex flex-wrap items-center gap-3 border border-civix-purple/30 bg-civix-purple/5 p-4" data-testid="producer-page-banner">
      <BadgeCheck className="h-5 w-5 shrink-0 text-civix-purpleSoft" />
      <div className="min-w-0 flex-1 text-sm">
        <span className="font-semibold">Recommendation (Not Required):</span>{' '}
        <span className="text-white/80">Set up your Producer Validation Page.</span>
      </div>
      <Link to="/settings?tab=producer-page" className="rounded-lg bg-civix-purple px-3 py-1.5 text-xs font-bold text-white hover:bg-civix-purple/90">
        Set up now
      </Link>
      <button type="button" onClick={() => dismiss.mutate()} aria-label="Dismiss recommendation" className="rounded p-1 text-white/40 hover:text-white">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
